"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TodoItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const todo_item_style_1 = __importDefault(require("./todo.item.style"));
const icons_1 = require("../../icons");
class TodoItem extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, label, title, done, doing } = this.props;
            return (jsx_runtime_1.jsxs("dl", Object.assign({ className: classes.root, "data-is-doing": doing, "data-is-done": done }, { children: [jsx_runtime_1.jsxs("dt", Object.assign({ className: classes.label }, { children: [label, jsx_runtime_1.jsx("span", Object.assign({ className: classes.icon }, { children: jsx_runtime_1.jsx(icons_1.icons.CheckCircle, {}, void 0) }), void 0)] }), void 0),
                    jsx_runtime_1.jsx("dd", Object.assign({ className: classes.title, "data-text": title }, { children: jsx_runtime_1.jsx("span", Object.assign({ className: classes.titleText }, { children: title }), void 0) }), void 0)] }), void 0));
        };
    }
}
exports.TodoItem = TodoItem;
TodoItem.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    label: prop_types_1.default.string.isRequired,
    title: prop_types_1.default.string.isRequired,
    done: prop_types_1.default.bool,
    doing: prop_types_1.default.bool
};
TodoItem.defaultProps = {
    done: false,
    doing: false
};
exports.default = react_jss_1.default(todo_item_style_1.default)(TodoItem);
//# sourceMappingURL=todo.item.js.map